import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    remoteProperty:null
}

export const remoteConfigSlice = createSlice({
  name: 'remote',
  initialState,
  reducers: {
    setRemoteProperty: (state, action) => {
      state.remoteProperty = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setRemoteProperty } = remoteConfigSlice.actions

export default remoteConfigSlice.reducer